import React from 'react';

import { Alert, AlertTitle } from '@mui/material';

import { useVerificationRequestFormData } from 'src/hooks/verificationRequest';

export const ConsumerFreezeErrorBox: React.FC = () => {
  const { isEmployeeExists, isEmployeeFrozen } = useVerificationRequestFormData();

  if (isEmployeeExists && isEmployeeFrozen) {
    return (
      <Alert sx={{ mt: 2 }} severity="error">
        <AlertTitle>Employee Account is frozen</AlertTitle>
        This employee is not accepting verification requests from commercial verifiers.
      </Alert>
    );
  }

  return null;
};
